import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const PAGE_SIZE = 50;

export const GET_FULFILS = gql`
  query getFulfils(
    $accountId: Int
    $sourceAccountId: Int
    $roleId: Int
    $state: FulfilState
    $venueId: Int
    $lookBack: LookBack
    $offset: Int!
    $limit: Int!
  ) {
    fulfils(
      accountId: $accountId
      sourceAccountId: $sourceAccountId
      roleId: $roleId
      venueId: $venueId
      state: $state
      lookBack: $lookBack
      offset: $offset
      limit: $limit
    ) {
      total

      data {
        id
        createdAt
        state

        member {
          id
          firstName
          lastName
        }

        stream {
          id
          accountId
          state
          shiftId
          key

          account {
            id
            provider
            name
          }

          shift {
            id
            startTime
            endTime
            sourceAccount {
              id
              accountName
            }
            role {
              id
              name
            }
            venue {
              id
              name
            }
            subvenue {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const useFulfils = (
  {
    accountId,
    sourceAccountId,
    roleId,
    venueId,
    state,
    lookBack,
  }: {
    accountId: number | null;
    sourceAccountId: number | null;
    roleId: number | null;
    venueId: number | null;
    state: string | null;
    lookBack: string | null;
  },
  page = 1,
) => {
  const safePage = Math.max(1, page);
  const offset = (safePage - 1) * PAGE_SIZE;

  const { data, previousData, loading, networkStatus, refetch } = useQuery(
    GET_FULFILS,
    {
      client: shiftStreamClient,
      variables: {
        accountId,
        sourceAccountId,
        roleId,
        venueId,
        state,
        lookBack,
        offset,
        limit: PAGE_SIZE,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      onError: (error) => {
        throw error;
      },
    },
  );

  // Keep pagination metadata stable while the next page is loading.
  const resolvedData = data || previousData;

  const total = resolvedData?.fulfils?.total || 0;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    fulfils: resolvedData?.fulfils.data || [],
    total,
    totalPages,
    page: safePage,
    refetch,
  };
};
